import { PermissionInfo } from 'types/rolePermission'
import useUserSession from './useUserSession'
import { useMemo } from 'react'

const codeCanReadUsers = 'can-read-users'
const codeCanWriteUsers = 'can-write-users'
const codeCanReadTerms = 'can-read-terms'
const codeCanWriteTerms = 'can-write-terms'
const codeCanReadClients = 'can-read-clients'
const codeCanWriteClients = 'can-write-clients'
const codeCanReadDebtors = 'can-read-debtors'
const codeCanWriteDebtors = 'can-write-debtors'
const codeCanReadClientFundingInstructionList = 'can-read-client-funding-instruction-list'
const codeCanWriteClientFundingInstructionDetails = 'can-write-client-funding-instruction-details'
const codeCanReadClientFundingInstructionDetails = 'can-read-client-funding-instruction-details'
const codeCanPurchaseInvoices = 'can-purchase-invoices'
const codeCanCreateOrEditInvoices = 'can-write-invoices'
const codeCanCreateOrEditDisbursements = 'can-write-disbursements'
const codeCanApproveInvoices = 'can-approve-invoices'
const codeCanReadDisbursements = 'can-read-disbursements'
const codeCanReadInvoices = 'can-read-invoices'
const codeCanVerifyInvoices = 'can-verify-invoices'
const codeCanReadPayments = 'can-read-payments'
const codeCanWritePayments = 'can-write-payments'
const codeCanApplyPayments = 'can-apply-payments'
const codeCanReadManualLedgers = 'can-read-manual-ledgers'
const codeCanWriteManualLedgers = 'can-write-manual-ledgers'
const codeCanReadLedgers = 'can-read-ledgers'
const codeCanAccessNormalLevelReporting = 'can-access-normal-level-reporting'
const codeCanViewReportSchedules = 'can-view-report-schedules'
const codeCanManageReportSchedules = 'can-manage-report-schedules'
const codeCanWriteDocuments = 'can-write-documents'
const codeCanAdjustOtherUserSettings = 'can-adjust-other-user-settings'
const codeCanAccessAdminLevelSettings = 'can-access-admin-level-setting'
const codeCanReadDocuments = 'can-read-documents'
const codeCanReadAutocomplete = 'can-read-autocomplete'
const codeCanAccessFactorAdminSettings = 'can-access-factor-admin-settings'
const codeCanReadFuelAdvances = 'can-read-fuel-advances'
const codeCanWriteFuelAdvances = 'can-write-fuel-advances'
const codeCanWriteBrokers = 'can-write-brokers'
const codeCanReadBrokers = 'can-read-brokers'
const codeCanWriteVendors = 'can-write-vendors'
const codeCanReadVendors = 'can-read-vendors'
const codeCanWriteThirdParties = 'can-write-third-parties'
const codeCanReadThirdParties = 'can-read-third-parties'
const codeCanSetForcedInvoiceTerm = 'can-set-forced-invoice-term'
const codeCanReadTankPayment = 'can-read-tank-payments'
const codeCanWriteTankPayment = 'can-write-tank-payments'
const codeCanReadTexasCapitalPayment = 'can-read-texascapital-payments'
const codeCanWriteTexasCapitalPayment = 'can-write-texascapital-payments'
const codeCanWriteOpenInvoices = 'can-write-open-invoices'
const codeCanWriteClosedInvoices = 'can-write-closed-invoices'
const codeCanWriteLedgerName = 'can-write-ledger-name'
const codeCanReadLedgerName = 'can-read-ledger-name'
const codeCanWriteVerificationMethod = 'can-write-verification-method'
const codeCanReadVerificationMethod = 'can-read-verification-method'
const codeCanWriteOutOfSystemInvoice = 'can-write-out-of-system-invoice'
const codeCanReadOutOfSystemInvoice = 'can-read-out-of-system-invoice'
const codeCanReadEmailLogs = 'can-read-email-logs'
const codeCanReadReserveReleases = 'can-read-reserve-releases'
const codeCanWriteReserveReleases = 'can-write-reserve-releases'
const codeCanAccessClientAdminSettings = 'can-access-client-admin-settings'
const codeCanAccessAdminPaymentAccounts = 'can-access-admin-payment-accounts'
const codeCanWriteLabels = 'can-write-labels'
const codeCanModifyFactorDefaultValues = 'can-modify-factor-default-values'
const codeAccessDocuments = 'brightbolt-access'
const codeCanRebillInvoices = 'can-rebill-invoices'
const codeCanWriteNoaSettings = 'can-edit-noa-settings'
const codeCanWritePaymentBatches = 'can-write-payment-batch'
const codeCanCreateAutomatedPayments = 'can-create-automated-payments'
const codeCanReadPaymentBatches = 'can-read-payment-batch'
const codeCanBypassCreditLimit = 'can-bypass-credit-limit'
const codeCanBypassNoBuy = 'can-bypass-no-buy'
const codeCanManageRoles = 'can-manage-roles'
const codeCanEditCreditLimits = 'can-edit-credit-limits'
const codeCanEditCreditLimitsClients = 'can-edit-credit-limits-clients'
const codeCanEditCreditLimitsBrokers = 'can-edit-credit-limits-brokers'
const codeCanEditCreditLimitsDebtors = 'can-edit-credit-limits-debtors'
const codeCanEditCreditLimitsClientDebtors = 'can-edit-credit-limits-client-debtors'
const codeCanEditCreditLimitsBrokerDebtors = 'can-edit-credit-limits-broker-debtors'
const codeCanWriteInvoiceLineItems = 'can-write-invoice-line-item'
const codeCanReadAutomation = 'can-read-automation'
const codeCanWriteAutomation = 'can-write-automation'
const codeCanBypassOffsettingEntry = 'can-bypass-offsetting-entry'
const codeCanApplyFundingChargebacks = 'can-apply-funding-chargebacks'
const codeCanApplyFuelAdvanceChargebacks = 'can-apply-fuel-advance-chargebacks'
const codeCanCreateWriteOffs = 'can-create-write-off'
const codeCanWriteOffOverAdvances = 'can-write-off-over-advances'
const codeCanWriteOverAdvances = 'can-create-over-advances'
const codeCanReadOverAdvances = 'can-read-over-advances'
const codeCanFundOverAdvances = 'can-fund-over-advances'
const codeCanUpdateCostOfFundsInterest = 'can-update-cost-of-funds-interest'
const codeCanReadCommissionPartners = 'can-read-commission-partners'
const codeCanWriteCommissionPartners = 'can-write-commission-partners'
const codeCanManageCommissionPartnersRelations = 'can-manage-commission-partner-relations'
const codeCanReadCommissionTemplates = 'can-read-commission-templates'
const codeCanWriteCommissionTemplates = 'can-write-commission-templates'
const codeCanReadOverAdvanceTemplates = 'can-read-over-advance-templates'
const codeCanWriteOverAdvanceTemplates = 'can-write-over-advance-templates'
const codeCanReadCommissionBonuses = 'can-read-commission-bonuses'
const codeCanWriteCommissionBonuses = 'can-write-commission-bonuses'
const codeCanWriteCustomGlCodes = 'can-write-custom-gl-codes'
const codeCanReadGlCodeAliases = 'can-read-gl-code-aliases'
const codeCanWriteGlCodeAliases = 'can-write-gl-code-aliases'
const codeCanWriteCollectionStatus = 'can-write-collection-status'
const codeCanUndoPayments = 'can-undo-payments'

export function hasPermission(permissionsToCheck: string[], userPermissions: PermissionInfo[] = []) {
  const pList = userPermissions.map((p) => p.code)
  return permissionsToCheck.some((permission) => pList.includes(permission))
}

const usePermissions = () => {
  const { permissions } = useUserSession()

  const canReadUsers = useMemo(() => hasPermission([codeCanReadUsers, codeCanWriteUsers], permissions), [permissions])
  const canWriteUsers = useMemo(() => hasPermission([codeCanWriteUsers], permissions), [permissions])
  const canReadTerms = useMemo(() => hasPermission([codeCanReadTerms, codeCanWriteTerms], permissions), [permissions])
  const canWriteTerms = useMemo(() => hasPermission([codeCanWriteTerms], permissions), [permissions])
  const canReadClients = useMemo(
    () => hasPermission([codeCanReadClients, codeCanWriteClients], permissions),
    [permissions]
  )
  const canWriteClients = useMemo(() => hasPermission([codeCanWriteClients], permissions), [permissions])
  const canReadDebtors = useMemo(
    () => hasPermission([codeCanReadDebtors, codeCanWriteDebtors], permissions),
    [permissions]
  )
  const canWriteDebtors = useMemo(() => hasPermission([codeCanWriteDebtors], permissions), [permissions])
  const canReadClientFundingInstructionList = useMemo(
    () =>
      hasPermission(
        [
          codeCanReadClientFundingInstructionList,
          codeCanReadClientFundingInstructionDetails,
          codeCanWriteClientFundingInstructionDetails,
        ],
        permissions
      ),
    [permissions]
  )
  const canReadClientFundingInstructionDetails = useMemo(
    () =>
      hasPermission(
        [codeCanReadClientFundingInstructionDetails, codeCanWriteClientFundingInstructionDetails],
        permissions
      ),
    [permissions]
  )
  const canWriteClientFundingInstructionDetails = useMemo(
    () => hasPermission([codeCanWriteClientFundingInstructionDetails], permissions),
    [permissions]
  )
  const canReadInvoices = useMemo(
    () =>
      hasPermission(
        [codeCanReadInvoices, codeCanCreateOrEditInvoices, codeCanVerifyInvoices, codeCanApproveInvoices],
        permissions
      ),
    [permissions]
  )
  const canWriteInvoices = useMemo(() => hasPermission([codeCanCreateOrEditInvoices], permissions), [permissions])
  const canPurchaseInvoices = useMemo(() => hasPermission([codeCanPurchaseInvoices], permissions), [permissions])
  const canApproveInvoices = useMemo(() => hasPermission([codeCanApproveInvoices], permissions), [permissions])
  const canVerifyInvoices = useMemo(() => hasPermission([codeCanVerifyInvoices], permissions), [permissions])
  const canReadDisbursements = useMemo(
    () =>
      hasPermission([codeCanReadDisbursements, codeCanCreateOrEditDisbursements, codeCanPurchaseInvoices], permissions),
    [permissions]
  )
  const canWriteDisbursements = useMemo(
    () => hasPermission([codeCanCreateOrEditDisbursements], permissions),
    [permissions]
  )
  const canReadPayments = useMemo(
    () => hasPermission([codeCanReadPayments, codeCanWritePayments, codeCanApplyPayments], permissions),
    [permissions]
  )
  const canApplyPayments = useMemo(() => hasPermission([codeCanApplyPayments], permissions), [permissions])
  const canWritePayments = useMemo(() => hasPermission([codeCanWritePayments], permissions), [permissions])

  const canReadManualLedgers = useMemo(
    () => hasPermission([codeCanReadManualLedgers, codeCanWriteManualLedgers], permissions),
    [permissions]
  )

  const canWriteManualLedgers = useMemo(() => hasPermission([codeCanWriteManualLedgers], permissions), [permissions])

  const canReadLedgers = useMemo(() => hasPermission([codeCanReadLedgers], permissions), [permissions])

  const canAccessNormalLevelReporting = useMemo(
    () => hasPermission([codeCanAccessNormalLevelReporting], permissions),
    [permissions]
  )

  const canViewReportSchedules = useMemo(
    () => hasPermission([codeCanViewReportSchedules, codeCanManageReportSchedules], permissions),
    [permissions]
  )

  const canManageReportSchedules = useMemo(() => hasPermission([codeCanManageReportSchedules], permissions), [permissions])

  const canReadDocuments = useMemo(
    () => hasPermission([codeCanReadDocuments, codeCanWriteDocuments], permissions),
    [permissions]
  )

  const canWriteDocuments = useMemo(() => hasPermission([codeCanWriteDocuments], permissions), [permissions])

  const canAdjustOtherUserSettings = useMemo(
    () => hasPermission([codeCanAdjustOtherUserSettings], permissions),
    [permissions]
  )

  const canAccessAdminLevelSettings = useMemo(
    () => hasPermission([codeCanAccessAdminLevelSettings], permissions),
    [permissions]
  )

  const canReadAutocomplete = useMemo(() => hasPermission([codeCanReadAutocomplete], permissions), [permissions])
  const canAccessFactorAdminSettings = useMemo(
    () => hasPermission([codeCanAccessFactorAdminSettings], permissions),
    [permissions]
  )

  const canReadFuelAdvances = useMemo(
    () => hasPermission([codeCanReadFuelAdvances, codeCanWriteFuelAdvances], permissions),
    [permissions]
  )

  const canWriteFuelAdvances = useMemo(() => hasPermission([codeCanWriteFuelAdvances], permissions), [permissions])

  const canReadBrokers = useMemo(
    () => hasPermission([codeCanReadBrokers, codeCanWriteBrokers], permissions),
    [permissions]
  )

  const canWriteBrokers = useMemo(() => hasPermission([codeCanWriteBrokers], permissions), [permissions])

  const canReadVendors = useMemo(
    () => hasPermission([codeCanWriteVendors, codeCanReadVendors], permissions),
    [permissions]
  )
  const canWriteVendors = useMemo(() => hasPermission([codeCanWriteVendors], permissions), [permissions])

  const canReadThirdParties = useMemo(
    () => hasPermission([codeCanWriteThirdParties, codeCanReadThirdParties], permissions),
    [permissions]
  )
  const canWriteThirdParties = useMemo(() => hasPermission([codeCanWriteThirdParties], permissions), [permissions])

  const canSetForcedInvoiceTerm = useMemo(
    () => hasPermission([codeCanSetForcedInvoiceTerm], permissions),
    [permissions]
  )

  const canReadTankPayments = useMemo(
    () => hasPermission([codeCanReadTankPayment, codeCanWriteTankPayment], permissions),
    [permissions]
  )

  const canWriteTankPayments = useMemo(() => hasPermission([codeCanWriteTankPayment], permissions), [permissions])

  const canReadTexasCapitalPayments = useMemo(
    () => hasPermission([codeCanReadTexasCapitalPayment, codeCanWriteTexasCapitalPayment], permissions),
    [permissions]
  )

  const canWriteTexasCapitalPayments = useMemo(
    () => hasPermission([codeCanWriteTexasCapitalPayment], permissions),
    [permissions]
  )

  const canWriteOpenInvoices = useMemo(() => hasPermission([codeCanWriteOpenInvoices], permissions), [permissions])
  const canWriteClosedInvoices = useMemo(() => hasPermission([codeCanWriteClosedInvoices], permissions), [permissions])

  const canWriteLedgerName = useMemo(() => hasPermission([codeCanWriteLedgerName], permissions), [permissions])

  const canReadLedgerName = useMemo(
    () => hasPermission([codeCanReadLedgerName, codeCanWriteLedgerName], permissions),
    [permissions]
  )

  const canWriteVerificationMethod = useMemo(
    () => hasPermission([codeCanWriteVerificationMethod], permissions),
    [permissions]
  )
  const canReadVerificationMethod = useMemo(
    () => hasPermission([codeCanReadVerificationMethod, codeCanWriteVerificationMethod], permissions),
    [permissions]
  )

  const canWriteOutOfSystemInvoice = useMemo(
    () => hasPermission([codeCanWriteOutOfSystemInvoice], permissions),
    [permissions]
  )

  const canReadOutOfSystemInvoice = useMemo(
    () => hasPermission([codeCanWriteOutOfSystemInvoice, codeCanReadOutOfSystemInvoice], permissions),
    [permissions]
  )
  const canReadEmailLogs = useMemo(() => hasPermission([codeCanReadEmailLogs], permissions), [permissions])

  const canReadReserveReleases = useMemo(
    () => hasPermission([codeCanReadReserveReleases, codeCanWriteReserveReleases], permissions),
    [permissions]
  )

  const canWriteReserveReleases = useMemo(
    () => hasPermission([codeCanWriteReserveReleases], permissions),
    [permissions]
  )

  const canAccessClientAdminSettings = useMemo(
    () => hasPermission([codeCanAccessClientAdminSettings], permissions),
    [permissions]
  )

  const canAccessAdminPaymentAccounts = useMemo(
    () => hasPermission([codeCanAccessAdminPaymentAccounts], permissions),
    [permissions]
  )

  const canWriteLabels = useMemo(() => hasPermission([codeCanWriteLabels], permissions), [permissions])

  const canModifyFactorDefaultValues = useMemo(
    () => hasPermission([codeCanModifyFactorDefaultValues], permissions),
    [permissions]
  )

  const canAccessDocuments = useMemo(() => hasPermission([codeAccessDocuments], permissions), [permissions])

  const canRebillInvoices = useMemo(() => hasPermission([codeCanRebillInvoices], permissions), [permissions])

  const canWriteNoaSettings = useMemo(() => hasPermission([codeCanWriteNoaSettings], permissions), [permissions])

  const canWritePaymentBatches = useMemo(() => hasPermission([codeCanWritePaymentBatches], permissions), [permissions])

  const canCreateAutomatedPayments = useMemo(
    () => hasPermission([codeCanCreateAutomatedPayments], permissions),
    [permissions]
  )

  const canReadPaymentBatches = useMemo(() => hasPermission([codeCanReadPaymentBatches], permissions), [permissions])

  const canBypassCreditLimit = useMemo(() => hasPermission([codeCanBypassCreditLimit], permissions), [permissions])
  const canBypassNoBuy = useMemo(() => hasPermission([codeCanBypassNoBuy], permissions), [permissions])

  const canManageRoles = useMemo(() => hasPermission([codeCanManageRoles], permissions), [permissions])

  // Only checks the account-wide main permission — used exclusively for the credit request
  // approval flow, which per business rule never honors the granular per-entity permissions below.
  const canEditCreditLimits = useMemo(() => hasPermission([codeCanEditCreditLimits], permissions), [permissions])

  // Granular per-entity-type "Edit Credit Limits" — main permission still overrides.
  const canEditClientCreditLimits = useMemo(
    () => hasPermission([codeCanEditCreditLimits, codeCanEditCreditLimitsClients], permissions),
    [permissions]
  )
  const canEditBrokerCreditLimits = useMemo(
    () => hasPermission([codeCanEditCreditLimits, codeCanEditCreditLimitsBrokers], permissions),
    [permissions]
  )
  const canEditDebtorCreditLimits = useMemo(
    () => hasPermission([codeCanEditCreditLimits, codeCanEditCreditLimitsDebtors], permissions),
    [permissions]
  )
  const canEditClientDebtorCreditLimits = useMemo(
    () => hasPermission([codeCanEditCreditLimits, codeCanEditCreditLimitsClientDebtors], permissions),
    [permissions]
  )
  const canEditBrokerDebtorCreditLimits = useMemo(
    () => hasPermission([codeCanEditCreditLimits, codeCanEditCreditLimitsBrokerDebtors], permissions),
    [permissions]
  )
  // Same permission set the backend gates No Buy itself behind.
  const canManageNoBuyReasons = useMemo(
    () =>
      hasPermission(
        [
          codeCanEditCreditLimits,
          codeCanEditCreditLimitsClients,
          codeCanEditCreditLimitsBrokers,
          codeCanEditCreditLimitsDebtors,
        ],
        permissions
      ),
    [permissions]
  )

  const canWriteInvoiceLineItems = useMemo(
    () => hasPermission([codeCanWriteInvoiceLineItems], permissions),
    [permissions]
  )

  const canWriteAutomation = useMemo(() => hasPermission([codeCanWriteAutomation], permissions), [permissions])

  const canReadAutomation = useMemo(
    () => hasPermission([codeCanReadAutomation, codeCanWriteAutomation], permissions),
    [permissions]
  )

  const canBypassOffsettingEntry = useMemo(
    () => hasPermission([codeCanBypassOffsettingEntry], permissions),
    [permissions]
  )

  const canApplyFundingChargebacks = useMemo(
    () => hasPermission([codeCanApplyFundingChargebacks], permissions),
    [permissions]
  )

  const canApplyFuelAdvanceChargebacks = useMemo(
    () => hasPermission([codeCanApplyFuelAdvanceChargebacks], permissions),
    [permissions]
  )

  const canCreateWriteOffs = useMemo(() => hasPermission([codeCanCreateWriteOffs], permissions), [permissions])

  const canWriteOffOverAdvances = useMemo(() => hasPermission([codeCanWriteOffOverAdvances], permissions), [permissions])

  const canWriteOverAdvances = useMemo(() => hasPermission([codeCanWriteOverAdvances], permissions), [permissions])

  const canReadOverAdvances = useMemo(
    () => hasPermission([codeCanReadOverAdvances, codeCanWriteOverAdvances], permissions),
    [permissions]
  )

  const canFundOverAdvances = useMemo(() => hasPermission([codeCanFundOverAdvances], permissions), [permissions])

  const canUpdateCostOfFundsInterest = useMemo(
    () => hasPermission([codeCanUpdateCostOfFundsInterest], permissions),
    [permissions]
  )

  const canReadCommissionPartners = useMemo(
    () => hasPermission([codeCanReadCommissionPartners, codeCanWriteCommissionPartners], permissions),
    [permissions]
  )

  const canWriteCommissionPartners = useMemo(
    () => hasPermission([codeCanWriteCommissionPartners], permissions),
    [permissions]
  )

  const canManageCommissionPartnersRelations = useMemo(
    () => hasPermission([codeCanManageCommissionPartnersRelations], permissions),
    [permissions]
  )

  const canReadCommissionTemplates = useMemo(
    () => hasPermission([codeCanReadCommissionTemplates, codeCanWriteCommissionTemplates], permissions),
    [permissions]
  )

  const canWriteCommissionTemplates = useMemo(
    () => hasPermission([codeCanWriteCommissionTemplates], permissions),
    [permissions]
  )

  const canReadOverAdvanceTemplates = useMemo(
    () => hasPermission([codeCanReadOverAdvanceTemplates, codeCanWriteOverAdvanceTemplates], permissions),
    [permissions]
  )

  const canWriteOverAdvanceTemplates = useMemo(
    () => hasPermission([codeCanWriteOverAdvanceTemplates], permissions),
    [permissions]
  )

  const canReadCommissionBonuses = useMemo(
    () => hasPermission([codeCanReadCommissionBonuses, codeCanWriteCommissionBonuses], permissions),
    [permissions]
  )
  const canWriteCommissionBonuses = useMemo(
    () => hasPermission([codeCanWriteCommissionBonuses], permissions),
    [permissions]
  )

  const canWriteCustomGlCodes = useMemo(() => hasPermission([codeCanWriteCustomGlCodes], permissions), [permissions])
  const canReadGlCodeAliases = useMemo(
    () => hasPermission([codeCanReadGlCodeAliases, codeCanWriteGlCodeAliases], permissions),
    [permissions]
  )
  const canWriteGlCodeAliases = useMemo(() => hasPermission([codeCanWriteGlCodeAliases], permissions), [permissions])

  const canWriteCollectionStatus = useMemo(
    () => hasPermission([codeCanWriteCollectionStatus], permissions),
    [permissions]
  )

  const canUndoPayments = useMemo(() => hasPermission([codeCanUndoPayments], permissions), [permissions])

  return {
    canReadUsers,
    canWriteUsers,
    canReadTerms,
    canWriteTerms,
    canReadClients,
    canWriteClients,
    canReadDebtors,
    canWriteDebtors,
    canReadClientFundingInstructionList,
    canReadClientFundingInstructionDetails,
    canWriteClientFundingInstructionDetails,
    canReadInvoices,
    canWriteInvoices,
    canPurchaseInvoices,
    canApproveInvoices,
    canVerifyInvoices,
    canReadDisbursements,
    canWriteDisbursements,
    canReadPayments,
    canWritePayments,
    canApplyPayments,
    canReadManualLedgers,
    canWriteManualLedgers,
    canReadLedgers,
    canAccessNormalLevelReporting,
    canViewReportSchedules,
    canManageReportSchedules,
    canReadDocuments,
    canWriteDocuments,
    canAdjustOtherUserSettings,
    canAccessAdminLevelSettings,
    canReadAutocomplete,
    canAccessFactorAdminSettings,
    canReadFuelAdvances,
    canWriteFuelAdvances,
    canReadBrokers,
    canWriteBrokers,
    canWriteVendors,
    canReadVendors,
    canWriteThirdParties,
    canReadThirdParties,
    canSetForcedInvoiceTerm,
    canReadTankPayments,
    canWriteTankPayments,
    canReadTexasCapitalPayments,
    canWriteTexasCapitalPayments,
    canWriteOpenInvoices,
    canWriteClosedInvoices,
    canWriteLedgerName,
    canReadLedgerName,
    canWriteVerificationMethod,
    canReadVerificationMethod,
    canWriteOutOfSystemInvoice,
    canReadOutOfSystemInvoice,
    canReadEmailLogs,
    canReadReserveReleases,
    canWriteReserveReleases,
    canAccessClientAdminSettings,
    canAccessAdminPaymentAccounts,
    canWriteLabels,
    canModifyFactorDefaultValues,
    canAccessDocuments,
    canRebillInvoices,
    canWriteNoaSettings,
    canWritePaymentBatches,
    canCreateAutomatedPayments,
    canReadPaymentBatches,
    canBypassCreditLimit,
    canBypassNoBuy,
    canEditCreditLimits,
    canEditClientCreditLimits,
    canEditBrokerCreditLimits,
    canEditDebtorCreditLimits,
    canEditClientDebtorCreditLimits,
    canEditBrokerDebtorCreditLimits,
    canManageNoBuyReasons,
    canManageRoles,
    canWriteInvoiceLineItems,
    canReadAutomation,
    canWriteAutomation,
    canBypassOffsettingEntry,
    canApplyFundingChargebacks,
    canApplyFuelAdvanceChargebacks,
    canCreateWriteOffs,
    canWriteOffOverAdvances,
    canWriteOverAdvances,
    canReadOverAdvances,
    canFundOverAdvances,
    canUpdateCostOfFundsInterest,
    canReadCommissionPartners,
    canWriteCommissionPartners,
    canManageCommissionPartnersRelations,
    canReadCommissionTemplates,
    canWriteCommissionTemplates,
    canReadOverAdvanceTemplates,
    canWriteOverAdvanceTemplates,
    canReadCommissionBonuses,
    canWriteCommissionBonuses,
    canWriteCustomGlCodes,
    canReadGlCodeAliases,
    canWriteGlCodeAliases,
    canWriteCollectionStatus,
    canUndoPayments,
  }
}

export default usePermissions
